import React from 'react';
import Icon from '../../../components/AppIcon';

const ProductionMetricsPanel = ({ metrics, batches }) => {
  const metricCards = [
    {
      label: 'Lots Totaux',
      value: metrics?.totalBatches || 0,
      icon: 'Package',
      color: 'bg-primary/10 text-primary',
      trend: null
    },
    {
      label: 'En Production',
      value: metrics?.activeBatches || 0,
      icon: 'Play',
      color: 'bg-blue-100 text-blue-600',
      trend: null
    },
    {
      label: 'Terminés Aujourd\'hui',
      value: metrics?.completedToday || 0,
      icon: 'CheckCircle',
      color: 'bg-success/10 text-success',
      trend: '+12%'
    },
    {
      label: 'Contrôle Qualité',
      value: metrics?.qualityCheckBatches || 0,
      icon: 'Shield',
      color: 'bg-warning/10 text-warning',
      trend: null
    },
    {
      label: 'Retards',
      value: metrics?.delayedBatches || 0,
      icon: 'AlertCircle',
      color: 'bg-error/10 text-error',
      trend: '-5%'
    },
    {
      label: 'Progression Moyenne',
      value: `${metrics?.avgProgress || 0}%`,
      icon: 'TrendingUp',
      color: 'bg-purple-100 text-purple-600',
      trend: null
    },
    {
      label: 'Taux Livraison À Temps',
      value: `${metrics?.onTimeRate || 0}%`,
      icon: 'Target',
      color: 'bg-green-100 text-green-600',
      trend: '+3%'
    }
  ];

  const recentActivity = batches?.slice(0, 5)?.map(batch => ({
    id: batch?.id,
    batchNumber: batch?.batchNumber,
    status: batch?.status,
    timestamp: new Date(batch?.updatedAt)
  }));

  return (
    <div className="space-y-6">
      {/* Metrics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {metricCards?.map((metric, index) => (
          <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <div className={`w-12 h-12 rounded-full ${metric?.color} flex items-center justify-center`}>
                <Icon name={metric?.icon} size={24} />
              </div>
              {metric?.trend && (
                <span className={`text-xs font-semibold ${
                  metric?.trend?.startsWith('+') ? 'text-success' : 'text-error'
                }`}>
                  {metric?.trend}
                </span>
              )}
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-1">{metric?.value}</div>
            <div className="text-sm text-gray-600">{metric?.label}</div>
          </div>
        ))}
      </div>

      {/* Recent Activity */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Activité Récente</h3>
        <div className="space-y-3">
          {recentActivity?.map(activity => (
            <div key={activity?.id} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
              <div className="flex items-center gap-3">
                <Icon name="QrCode" size={20} className="text-gray-400" />
                <div>
                  <div className="font-medium text-gray-900">{activity?.batchNumber}</div>
                  <div className="text-xs text-gray-600">
                    {activity?.timestamp?.toLocaleString('fr-FR')}
                  </div>
                </div>
              </div>
              <span className="text-sm font-medium text-gray-700 capitalize">
                {activity?.status?.replace('_', ' ')}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductionMetricsPanel;